//local
import { IUserContextReducerActionAll } from "./interface";
import { IUserContextState } from "./context";
//helper
import st from "1-quarks/sneaky-ton";
const path = "/1-quark/context/User/reducer";

export const UserContextReducer = (
  state: IUserContextState,
  action: IUserContextReducerActionAll
): IUserContextState => {
  st.run({ type: "start", path, fn: "UserContextReducer" });
  switch (action.type) {
    case "AUTH_DEL": //logout
      return { ...state, auth: null };
    case "AUTH_SET": //login
      const { type, ...authSetData } = action;
      return {
        ...state,
        auth: authSetData,
      };
    case "TRADES_SET": //login
      return {
        ...state,
        trades: action.trades,
      };

    //tags
    case "TAGS_SET":
      return {
        ...state,
        tags: action.tags,
      };
    case "TAGS_ADD":
      return {
        ...state,
        tags: { ...state.tags, ...action.tags },
      };
    case "TAGS_DEL":
      const { [action.tagName]: tmpTagDel, ...tagDel } = state.tags;
      return {
        ...state,
        tags: tagDel,
      };

    case "SYMBOLS_SET":
      return {
        ...state,
        symbols: action.symbols,
      };
    case "SYMBOLS_ADD":
      return {
        ...state,
        symbols: { ...state.symbols, ...action.symbols },
      };
    case "SYMBOLS_DEL":
      const { [action.symbolName]: tmpSymbolDel, ...symbolDel } = state.symbols;
      return {
        ...state,
        symbols: symbolDel,
      };
    default:
      return state;
  }
};
